import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
	Grid,
	Box,
	FormControl,
	MenuItem,
	Select,
	InputLabel,
	IconButton,
	useMediaQuery,
	Tooltip
} from '@material-ui/core';
import TimeField from './TimeField';
import DateFnsUtils from '@date-io/date-fns';
import { datePrefix, dateToCron } from 'helper/utils';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import reportSettingStyles from '../ReportSettings.style';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { QUARTER_TOOLTIP, MONTH_QUARTER, DAY_MONTH } from 'constants/constant';

function Quarter(props) {
	const {
		scheduleType,
		selectedDate,
		handleDateChange,
		selectQuarter,
		setSelectQuarter,
		dateSelect,
		handleDateSelect,
		setCronExpression,
		isDynamicSelected
	} = props;
	const isSmallScreen = useMediaQuery('(max-width:360px)');
	const classes = reportSettingStyles();

	const handleQuarterChange = (event) => {
		setSelectQuarter(event.target.value);
	};

	useEffect(() => {
		const cronExp = dateToCron({
			selectedDateTime: selectedDate,
			weeks: '?',
			quarter: selectQuarter,
			cronType: scheduleType,
			selectedDate: dateSelect
		});
		setCronExpression(cronExp);
	}, [selectQuarter, dateSelect, selectedDate]);

	const TooltipIcon = () => {
		return (
			<Tooltip
				arrow
				title={QUARTER_TOOLTIP}
				placement={isSmallScreen ? 'bottom' : 'right'}
				classes={{ tooltip: classes.tooltip }}>
				<IconButton aria-label="delete">
					<InfoOutlinedIcon fontSize="medium" color="primary" />
				</IconButton>
			</Tooltip>
		);
	};

	return (
		<Grid container>
			<Grid item xs={9} sm={6} md={6} lg={6}>
				<Box
					className={`${classes.datePanel} ${
						isSmallScreen ? classes.space : classes.spaceBetween
					}`}>
					<FormControl variant="outlined" className={classes.dateField}>
						<Select
							labelId="week-label"
							id="week-select"
							value={selectQuarter}
							MenuProps={{ classes: { paper: classes.menuPaper } }}
							className={classes.text}
							onChange={handleQuarterChange}>
							{Array.apply(1, Array(3)).map(function (x, i) {
								const date = i + 1;
								return (
									<MenuItem
										className={`${classes.text} ${classes.menuItem}`}
										key={date}
										value={date}>{`${date}${datePrefix(date)}`}</MenuItem>
								);
							})}
						</Select>
					</FormControl>
					<InputLabel className={`${classes.labelMonth} ${classes.text}`} id="month">
						{MONTH_QUARTER}
					</InputLabel>
				</Box>
			</Grid>
			<Grid item xs={10} sm={6} md={6} lg={6}>
				<Box
					className={`${classes.datePanel} ${
						isSmallScreen ? classes.space : classes.spaceBetween
					}`}>
					<FormControl variant="outlined" className={classes.dateField}>
						<Select
							labelId="time-label"
							id="time-select"
							value={dateSelect}
							MenuProps={{ classes: { paper: classes.menuPaper } }}
							className={classes.text}
							onChange={handleDateSelect}>
							{Array.apply(1, Array(31)).map(function (x, i) {
								const date = i + 1;
								return (
									<MenuItem
										className={`${classes.text} ${classes.menuItem}`}
										key={`${date}${datePrefix(date)}`}
										value={date}>{`${date}${datePrefix(date)}`}</MenuItem>
								);
							})}
						</Select>
					</FormControl>
					<InputLabel className={`${classes.labelMonth} ${classes.text}`} id="month">
						{DAY_MONTH}
					</InputLabel>
					<Box>{TooltipIcon()}</Box>
				</Box>
			</Grid>
			{!isDynamicSelected && (
				<Grid item xs={12} sm={12} md={12} lg={12}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<Box className={`${classes.spaceBetween} ${classes.datePanel}`}>
							<TimeField
								scheduleType={scheduleType}
								className={classes.timeField}
								selectedDate={selectedDate}
								handleDateChange={handleDateChange}
							/>
						</Box>
					</MuiPickersUtilsProvider>
				</Grid>
			)}
		</Grid>
	);
}

Quarter.propTypes = {
	scheduleType: PropTypes.string.isRequired,
	selectedDate: PropTypes.string.isRequired,
	handleDateChange: PropTypes.func.isRequired,
	selectQuarter: PropTypes.number.isRequired,
	setSelectQuarter: PropTypes.func.isRequired,
	dateSelect: PropTypes.number.isRequired,
	handleDateSelect: PropTypes.func.isRequired,
	setCronExpression: PropTypes.func.isRequired
};

export default Quarter;
